module.exports = __webpack_public_path__ + "assets/img/track-top-text.cb680fab.svg";